import script from "./KycReviewItem.vue?vue&type=script&setup=true&lang=js"
export * from "./KycReviewItem.vue?vue&type=script&setup=true&lang=js"

import "./KycReviewItem.vue?vue&type=style&index=0&id=4a71d595&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a71d595"]])

export default __exports__